import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState } from "react";
import { useWindowSize } from "usehooks-ts";
import { EramPrompt } from "./EramPrompt.js";
import { eramFontDimensionMap, eramFontNameMap, getBitmapTextStyles } from "../../eramFont.js";
import { useOnMount } from "../hooks/useOnMount.js";
import { useCenterCursor } from "../hooks/useCenterCursor.js";
import { ViewItem } from "./ViewItem.js";
import { useCommonDispatch } from "../../createRootReducer.js";
export const eligibilityOverrideView = "ELIGIBILITY_PROMPT";
const fontFamily = eramFontNameMap[2];
const { width: fontWidth, height: fontHeight } = eramFontDimensionMap[fontFamily];
const tint = 0xf0f0f0;
export const EligibilityOverridePrompt = ({ ref, ...props }) => {
    const { prompt, setViewPosition } = props;
    const windowSize = useWindowSize();
    const [renderPrompt, setRenderPrompt] = useState(false);
    const title = `${prompt.callsign} ${prompt.title}`;
    const width = Math.max(title.length, ...prompt.text.map((t) => t.length), 17) * fontWidth + 8;
    const height = Math.floor(fontHeight * (prompt.text.length + 4.3));
    useOnMount(() => {
        const pos = { x: (windowSize.width - width) / 2, y: (windowSize.height - height) / 2 };
        setViewPosition(pos);
        setRenderPrompt(true);
    }, true);
    return renderPrompt && _jsx(EligibilityOverridePromptActual, { ref: ref, ...props });
};
const EligibilityOverridePromptActual = ({ prompt, closePrompt, dispatchCommand, ref, ...promptProps }) => {
    const dispatch = useCommonDispatch();
    const localRef = useRef(null);
    const title = `${prompt.callsign} ${prompt.title}`;
    const width = Math.max(title.length, ...prompt.text.map((t) => t.length), 17) * fontWidth + 8;
    const height = Math.floor(fontHeight * (prompt.text.length + 4.3));
    useCenterCursor(localRef, width, fontHeight + 4);
    return (_jsxs(EramPrompt, { ref: ref, title: title, height: height, width: width, closeMenu: closePrompt, ...promptProps, children: [_jsx("bitmapText", { text: prompt.text.join("\n"), x: 4, y: 2, style: { ...getBitmapTextStyles(fontFamily), fill: tint } }), _jsxs("container", { y: Math.floor(height - fontHeight * 1.5), ref: localRef, children: [_jsx(ViewItem, { x: fontWidth, width: Math.floor(fontWidth * 4.5), text: "/OK", fillColor: 0x757575, tint: tint, onmousedown: () => {
                            dispatchCommand(prompt.command.elements);
                            closePrompt();
                        } }), _jsx(ViewItem, { x: width - Math.floor(fontWidth * 5.5), width: Math.floor(fontWidth * 4.5), text: "EXIT", fillColor: 0x757575, borderColor: 0x505050, tint: tint, onmousedown: closePrompt })] })] }));
};
//# sourceMappingURL=EligibilityOverridePrompt.js.map